import { Box } from '@mui/material'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Security, Instrument, instrumentToJSON } from '../../proto/generated/security'
import { OverviewWidgetResponse_IndexComponent } from '../../proto/generated/overview-widget'
import { RootState } from '../../store'
import useOverviewPanelNavigation from '../../hooks/useOverviewPanelNavigation'
import IndexComponents, { OVERVIEW_INDEX_COMPONENTS_LIMIT } from './IndexComponents'
import { OverviewMoreButton } from './OverviewSectionHeader'
import { OverviewSection, OVERVIEW_SECTION_IDS, OVERVIEW_SECTION_ORDER } from './OverviewSectionNav'

type Props = {
    indexComponents: OverviewWidgetResponse_IndexComponent[]
    security: Security | undefined
}

export const isIndexSecurity = (security: Security | undefined) =>
    security?.instrument === 'IDX' || security?.instrument === instrumentToJSON(Instrument.IDX)

const IndexComponentsSection = ({ indexComponents, security }: Props) => {
    const openComponentsPage = useOverviewPanelNavigation('components')
    const totalCount = useSelector((state: RootState) => state.overviewStore.indexComponentTotalCount)
    const hasContribution = useSelector((state: RootState) => state.overviewStore.hasIndexContribution)

    const handleOpenComponents = useCallback(() => {
        openComponentsPage(security)
    }, [openComponentsPage, security])

    if (!isIndexSecurity(security) || indexComponents.length === 0) {
        return null
    }

    const componentCount = Math.max(totalCount, indexComponents.length)
    const moreLabel =
        componentCount < OVERVIEW_INDEX_COMPONENTS_LIMIT
            ? 'Show detailed view'
            : `Show all ${componentCount} components`

    return (
        <OverviewSection
            id={OVERVIEW_SECTION_IDS.components}
            label="Components"
            order={OVERVIEW_SECTION_ORDER.components}
        >
            <IndexComponents
                indexComponents={indexComponents}
                showContribution={hasContribution}
            />
            <Box sx={{ px: 2, pb: 2 }}>
                <OverviewMoreButton
                    label={moreLabel}
                    onClick={handleOpenComponents}
                    eventName="Index Components Page Opened"
                />
            </Box>
        </OverviewSection>
    )
}

export default IndexComponentsSection
